export default __webpack_public_path__ + "static/media/lockpad_background.169f13ad.png";